
import {React, useState, useContext, useEffect, useRef} from "react"
import {useStyle} from '../../context/styleContext/styleContext'
import MobileProductCard from "./MobileProductCard"
import axios from 'axios'
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner"
import {Divider, Button, Box, Typography, useMediaQuery} from '@mui/material/';
import Rating from "@mui/material/Rating"
import HomePageProductCard from "../../components/ProductCard/HomePageProductCard"


export default function Plugins(){

  const [height, setHeight] = useState(window.innerHeight)
  const [width, setWidth] = useState(window.setWidth)
  const [dataForAllProducts, setDataForAllProducts] = useState([])
  const { style } = useStyle();



  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

  
//const isMobile = width <= 768;

const isMobile = useMediaQuery("(max-width: 768px)");

useEffect(() => {
  document.title = 'Parish Audio | Cutting-Edge Audio Processing | Plugins';
}, []);

const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);



    const getProductInfo = async (e) => {
      //const productURI = name
     // console.log("get product page info fired")
     //console.log("getting account info..")
      try{
        const {data} = await axios.post('/api/get-all-products')
        if(data)
        {
           // console.log(data)
           var result = [];
           var count = 0;

           for(var i in data){
               count++;
           }


          
           //console.log("number of reviews: ", count, "     ", result.length)
           setDataForAllProducts(data)
          //  console.log(data)
          //  console.log("************")
          //  console.log(data[0])


        }
        else{
            console.log('data error')
        }
      }
      catch
      {
        console.log('Error retrieving data...')
      }
      
  }
  useEffect(() => {
      getProductInfo();
  }, []);






    return(
        <><div className='image-background-1'>
          <div className='dark-alpha-80'>

           <div ref={topContainer} className='centered-main-container' style={{display:'flex', flexDirection:'column', width:'95%', maxWidth:'1000px', backgroundPosition: "center", minHeight:height - 130}}>
            <h1 className='left-centered-h1-mobile-margin10px'>All Plugins</h1>
          <div className='mobile-card-grid'>
          <Box sx={{mt:2, backgroundColor:style.color1, borderRadius:'8px', p:1, mb:1}}>

          {!isMobile && dataForAllProducts.length > 0 && (
<>
           <Box sx={{ display:'flex', flexDirection:'row', p:1}}>
            <Box sx={{flex:1, margin:'10px', boxShadow:10, filter:'brightness(1.05)'}}>
              <HomePageProductCard productData={dataForAllProducts[0]} />
            </Box>
            <Box sx={{flex:1, margin:'10px', boxShadow:10, filter:'brightness(1.05)'}}>
              <HomePageProductCard productData={dataForAllProducts[1]} />
            </Box>
            <Box sx={{flex:1, margin:'10px', boxShadow:10, filter:'brightness(1.05)'}}>
              <HomePageProductCard productData={dataForAllProducts[2]} />
            </Box>


                
       </Box>
       <Box sx={{ display:'flex', flexDirection:'row', p:1}}>
            <Box sx={{flex:1, margin:'10px', boxShadow:10, filter:'brightness(1.05)', maxWidth:'31%'}}>
              <HomePageProductCard productData={dataForAllProducts[3]} />
            </Box>


                
       </Box>
</>


          )}


      {isMobile && (
            
            <Box sx={{ display:'flex', flexDirection:'column'}}>
            {dataForAllProducts && dataForAllProducts.length > 0 ? (
  
              dataForAllProducts.map((product, index) => (
                <Box sx={{backgroundColor:style.color1, m:0.5, filter:'brightness(1.05)', boxShadow:10,p:1}}>
                     <HomePageProductCard key={index} productData={product} />
                </Box>
          ))
        ) : (
          <Box>
                  <LoadingSpinner />
          </Box>
        )}
        </Box>
 
 
 
           )}

          </Box>




          {/* {dataForAllProducts && dataForAllProducts.length > 0 ? (

            dataForAllProducts.map((product, index) => (
                  <Box sx={{m:2, backgroundColor:style.color1, maxWidth:'400px'}}>
                     <HomePageProductCard key={index} productData={product} />
                  </Box>
              
        ))
      ) : (
        <div>
                <LoadingSpinner />
        </div>
      )} */}
          </div>
          </div>

          </div>
        </div>
        
        </>
    )
}